import {
  UPDATE_PROFILE_START,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
} from './types';

export const updateProfileStart = (payload) => ({
  type: UPDATE_PROFILE_START,
  payload: payload,
})

export const updateProfileSuccess = (payload) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: payload,
})

export const updateProfileFailure = (payload) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload: payload,
})
